import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageType } from '../analytics/newrelic/enums/PageType';
import { MyAhaAnonymousComponent } from '../my-aha/my-aha-anonymous/my-aha-anonymous.component';
import { MyAhaComponent } from '../my-aha/my-aha.component';
import { SearchPageComponent } from '../search-page/search-page.component';
import { AuthGuard } from '../shared/guards/auth/auth.guard';
import { CollectionContainerResolver } from '../shared/resolvers/collection-container.resolver';
import { CoreResolver } from '../shared/resolvers/core.resolver';
import { StorefrontCombinedResolver } from '../shared/resolvers/storefront-combined.resolver';
import { StorefrontListResolver } from '../shared/resolvers/storefront-list.resolver';
import ShimmerRouteKey from '../shimmer/constants/shimmer-keys';
import { StorefrontComponent } from './storefront/storefront.component';
import { TvVerticalMenuComponent } from './tv-vertical-menu/tv-vertical-menu.component';
import { CollectionStorefrontComponent } from './collection-storefront/collection-storefront.component';

const getGenresRouting = (name: string) => ({
  path: name,
  data: {
    isStaticTab: true,
    preload: true,
    pageID: PageType.Collection,
    isCollection: true,
    shouldStop: true,
  },
  loadChildren: () =>
    import('../collection/collection.module').then((m) => m.CollectionModule),
});

const routes: Routes = [
  {
    path: '',
    component: TvVerticalMenuComponent,
    children: [
      {
        path: 'collection-storefront/:id',
        data: {
          shimmerKey: ShimmerRouteKey.Storefront,
          pageID: PageType.Browse,
          shouldReuse: true,
        },
        component: CollectionStorefrontComponent,
        resolve: {
          storefrontData: CollectionContainerResolver,
        },
      },
      getGenresRouting('genres'),
      getGenresRouting('view-all'),
      getGenresRouting('artist'),
      getGenresRouting('collection'),
      {
        path: 'my-aha',
        component: MyAhaComponent,
        canActivate: [AuthGuard],
        data: {
          shimmerKey: ShimmerRouteKey.MyAha,
          redirectPath: 'my-aha-link-tv',
          shouldSave: true,
          isStaticTab: true,
          pageID: PageType.MyAha,
          fetchProfiles: true,
          fetchEntitlements: true,
          isMyAha: true,
        },
        resolve: {
          coreData: CoreResolver,
        },
      },
      {
        path: 'my-aha-link-tv',
        component: MyAhaAnonymousComponent,
        data: {
          pageID: PageType.MyAha,
        },
      },
      {
        path: 'search',
        component: SearchPageComponent,
        data: {
          shouldReuse: true,
          isStaticTab: true,
          pageID: PageType.Search,
          fetchEntitlements: true,
        },
        resolve: {
          coreData: CoreResolver,
        },
      },
      {
        path: ':id',
        data: {
          shimmerKey: ShimmerRouteKey.Storefront,
          canUpdataCurrentResource: true,
          shouldReuse: true,
          shouldStop: true,
          isStorefront: true,
          pageID: PageType.Browse,
          fetchEntitlements: true,
          fetchProfiles: true,
          fetchVodCatlog: true,
        },
        component: StorefrontComponent,
        resolve: {
          storefrontData: StorefrontCombinedResolver,
        },
      },
      {
        path: '',
        data: {
          shimmerKey: ShimmerRouteKey.Storefront,
          shouldSave: true,
          isStorefrontTv: true,
          pageID: PageType.Browse,
          fetchProfiles: true,
        },
        component: StorefrontComponent,
        resolve: {
          storefrontData: StorefrontCombinedResolver,
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: [
    StorefrontListResolver,
    CoreResolver,
    StorefrontCombinedResolver,
    CollectionContainerResolver,
  ],
  exports: [RouterModule],
})
export class StorefrontRoutingModule {}
